export const TEMPLATE_NAME_MAX_LENGTH = 255;
